import React from "react";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
  HoverCardArrow,
} from "../HoverCard";

interface InfoButtonProps {
  examples?: string[];
  description?: string;
  className?: string;
}

const InfoButton: React.FC<InfoButtonProps> = ({
  examples = [],
  description,
  className = "",
}) => {
  if (!examples.length && !description) {
    return null;
  }

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <button
          type="button"
          className={`ml-2 inline-flex h-4 w-4 items-center justify-center rounded-full border border-gray-600 bg-gray-700 text-xs font-medium text-gray-400 transition-colors hover:bg-gray-600 hover:text-gray-300 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-800 focus:outline-none ${className} `}
          aria-label="Show examples and information"
        >
          ?
        </button>
      </HoverCardTrigger>
      <HoverCardContent
        side="top"
        align="start"
        className="w-80 border-gray-600 bg-gray-800 text-white"
      >
        <div className="space-y-2">
          {description && (
            <div>
              <h4 className="mb-1 text-sm font-medium text-gray-200">
                Description
              </h4>
              <p className="text-xs text-gray-300">{description}</p>
            </div>
          )}

          {examples.length > 0 && (
            <div>
              <h4 className="mb-1 text-sm font-medium text-gray-200">
                Examples
              </h4>
              <div className="flex flex-wrap gap-1">
                {examples.map((example, index) => (
                  <span
                    key={index}
                    className="inline-flex items-center rounded border border-gray-600 bg-gray-700 px-2 py-1 font-mono text-xs text-gray-200"
                  >
                    {example}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
        <HoverCardArrow className="fill-gray-800" />
      </HoverCardContent>
    </HoverCard>
  );
};

export { InfoButton };
